<template>
  <div class="LastMeasure">
    
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          Ostatni pomiar
        </p>
        <a href="#" class="card-header-icon" aria-label="more options">
          <span class="icon">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </a>
      </header>
      <div class="card-content">
        <div class="content">
          
          <div class="table-container">

           <table class="table is-bordered is-narrow">
                <thead>
                    <tr class="tableheader">
                        
                        <td >Odczyt</td>
                        <td colspan="10">Temperatury</td>
                        
                    </tr>    
                    <tr  class="tableheadersub">
                        
                        <td>Data</td>
                        <th>1.CO zasilanie 1</th>
                        <th>2.CO zasilanie 2</th>
                        <th>3.CO powrót 1</th>
                        <th>4.CO powrót 2</th>
                        <th>5.CW na budynek</th>
                        <th>6.CW na zasobnik z kotła</th>
                        <th>7.CW cyrkulacja</th>
                        <th>8.Kol-zejście glikolu</th>
                        <th>9.Kol-cyrkulacja</th>
                        <th>10.Kol-CWZ wymiennika</th>

                    </tr>
                </thead>

                <tbody v-for="el in datas" v-bind:key="el.id">
                    <tr>
                        <td>{{el.date}}</td>
                        <td>{{el.v0}}</td>
                        <td>{{el.v1}}</td>
                        <td>{{el.v2}}</td>
                        <td>{{el.v3}}</td>
                        <td>{{el.v4}}</td>
                        <td>{{el.v5}}</td>
                        <td>{{el.v6}}</td>
                        <td>{{el.v7}}</td>
                        <td>{{el.v8}}</td>
                        <td>{{el.v9}}</td>
                    </tr>    
                    

                </tbody>
     

           </table>
       
          </div>
        </div>
      </div>

      
    </div>
    
   
  </div>
</template>

<script>





export default {
  name: 'LastMeasure',
  components: {
    
   

  },
  computed: {
          
    
  },
  props: {
    
    
  },
  data() {
    return {
      datas: [
        {id: 0, v0: 0, title: ""},
        
      ]
    }
  },
  mounted () {

    for (let i = 0, lei = this.datas.length; i < lei; i++ ){
        console.log()
        let objData = {
            id: this.datas[i].id,
        
        }
        var _idw = this.datas[i].id;
        this.$store.dispatch('getLast', objData)
        .then(response => {
          console.log(_idw)
          console.log(response.data[0])
          this.buildForm(response.data[0])
        })
        .catch(error => {
            console.log("Error:")
            console.log(error)
            return error
        });
    

    }

    
  },
  methods: {
    buildForm(_data){
      
      this.datas[0].date = _data.date;   
      this.datas[0].v0 = _data.t0;          
      this.datas[0].v1 = _data.t1;          
      this.datas[0].v2 = _data.t2;          
      this.datas[0].v3 = _data.t3;          
      this.datas[0].v4 = _data.t4;          
      this.datas[0].v5 = _data.t5;          
      this.datas[0].v6 = _data.t6;           
      this.datas[0].v7 = _data.t7;         
      this.datas[0].v8 = _data.t8;         
      this.datas[0].v9 = _data.t9;         
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tableheader{
        background-color:#4a4a4a;
        color: #ffffff;
    }
    .tableheadersub {
        background-color:#4a4a4a;
        color: #ffffff !important;
    }
    .tableheadersub th{
        
        color: #ffffff !important;
    }
    .table td{
      color: #ffffff;
      background-color:#4a4a4a;
    }
    .card .card-content{
      background-color: #333 !important;
    }
    .card .card-footer{
      background-color: #333 !important;
    }
 
</style>
